import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicStatusPageOrigin } from '../utils/publicStatusPage';

/**
 * Redirects legacy /status/* paths on the main app to the public status subdomain.
 */
const PublicStatusRedirect = ({ segment }) => {
  const location = useLocation();

  useEffect(() => {
    const origin = getPublicStatusPageOrigin();
    if (!origin) return;
    const path = segment ? `/${segment}` : '/';
    window.location.replace(`${origin}${path}${location.search}`);
  }, [segment, location.search]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-[#111111]">
      <p className="text-sm text-[#6b7280] dark:text-[#9ca3af]">Redirecting…</p>
    </div>
  );
};

export default PublicStatusRedirect;
